module.exports = __webpack_public_path__ + "static/waterproof-mattress-protector-1-thumbnail-99c41417ec579ed54369ea1cebc017aa.png";